import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import axios from 'axios';
import useSnackbarStore from '@store/snackbar-store/snackbar.store.ts';
import { SnackbarType } from '@models/app-snackbar.model.ts';
import { CallStateEnum } from '@models/call-state.model.ts';
import { withCallState } from '@shared/store-features/call-state-feature.ts';
import { getOrganizationApiKey } from '@api/organization-api-key.api.ts';
import {
  ORGANIZATION_INITIAL_STATE,
  OrganizationState
} from '@modules/organization/store/organization.model.ts';

const useOrganizationStore = create<OrganizationState>()(
  devtools(
    (set, getState) => ({
      ...ORGANIZATION_INITIAL_STATE,
      ...withCallState(getState),

      getApiKey: async () => {
        set({ callState: CallStateEnum.Loading });
        try {
          const { token } = await getOrganizationApiKey();
          set({ token, callState: CallStateEnum.Loaded });
        } catch (error) {
          set({ callState: CallStateEnum.Error });
          if (axios.isAxiosError(error)) {
            const message = error.response?.data?.message;
            useSnackbarStore
              .getState()
              .showSnackbar(message, SnackbarType.Error);
          }
        }
      }
    }),
    { name: 'OrganizationStore' }
  )
);

export default useOrganizationStore;
